/**
 * Unlocalized Travo paths (under /travo). Wrap with localizePath(locale, ROUTES.x) for links;
 * the router registers each page under every locale.
 */
export const ROUTES = {
  home: '/',
  about: '/about-us',
  privacy: '/privacy',
  terms: '/terms',
  features: '/#features',
  plan: '/#plan'
} as const;

export type Route = (typeof ROUTES)[keyof typeof ROUTES];

/** Routes that are pages (not #sections). Router and prerender both read this list. */
export const PAGE_PATHS = [ROUTES.home, ROUTES.about, ROUTES.privacy, ROUTES.terms] as const;

export type PagePath = (typeof PAGE_PATHS)[number];
